/**
 * Derive the stable `code` from the label the ops types. The code is immutable once created and
 * never shown, so asking for it as a second field would be asking the ops to invent a key.
 * Accents are folded so « Électricité » and « Electricite » cannot both slip past the UNIQUE index.
 */
export const slugify = (label: string): string =>
  label
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 50);
